export default "__VITE_ASSET__C$fJ2WsO__"